import { AnonCartStore } from "../../stores/anon-cart/AnonCartStore";
import { CustomerCartStore } from "../../stores/customer-cart/CustomerCartStore";
import { SessionStore } from "../../uidispatcherapi/SessionStore";

import type { CommonCart } from "../../model/CommonCartTypes";
import { isFsdDeliveryDateBeforeCheckoutEnabled } from "../../ABFeatures";
import { AnonCartActions } from "../../actions/AnonCartActions";
import { CustomerCartActions } from "../../actions/CustomerCartActions";
import type { ArticleData } from "../../model/ArticleTypes";

export function getCartState(): CommonCart | null {
	if (SessionStore.loggedIn() === false) {
		return AnonCartStore.getCart();
	}
	return CustomerCartStore.getCart();
}

export function addItem(
	bundleId: string,
	quantity: number, // quantity to be added; for weight and weightPerPiece articles, this is a weight
	comment?: string | null, // only works for customercart AND for previous amount = 0
	articleData?: ArticleData | null, // only works for customercart AND for previous amount = 0; if provided, it will be used for an optimistic update
	source?: string | null, // only works for customercart; if provided, it will be used as eventIdPrefix
): void {
	const previousQuantity = getCartState()?.items[bundleId]?.quantity ?? 0;

	const totalQuantity = previousQuantity + quantity;

	if (SessionStore.loggedIn() === false) {
		return AnonCartActions.setItemQuantity(bundleId, totalQuantity);
	}
	if (previousQuantity == 0) {
		return CustomerCartActions.addItem({ quantity, bundleId, comment, articleData }, source);
	}

	return CustomerCartActions.setItemQuantity(bundleId, totalQuantity, source);
}

export function shouldShowDeliveryDate(): boolean {
	const cart = getCartState();
	const fsdDeliveryDate = cart?.fsdDeliveryDate ?? null;
	const hasNoArticles = Object.keys(cart?.items ?? {}).length === 0;
	const hasAtLeastOneFsdArticle = Object.values(cart?.items ?? {}).some(
		(item) => item.selectedFulfillmentType === "FSD",
	);
	return (
		isFsdDeliveryDateBeforeCheckoutEnabled() &&
		fsdDeliveryDate !== null &&
		(hasNoArticles || hasAtLeastOneFsdArticle)
	);
}
